<template>
    <div v-if="formInit">
        <InputRadio
                v-model:inputValue="registerModel.prefix"
                :inputLbl="lbl.register.prefix"
                :itemList="lbl.register.prefix_list"
                :errorInfo="errorInfo[0]"
                :isShowError="false"
                :isSubmitted="isSubmitted"
                @update:inputValue="onFormChange()"
        ></InputRadio>
        <div class="grid grid-cols-2 gap-y-0 gap-x-3 usm:gap-x-8 ">
            <InputText
                    v-model:inputValue="registerModel.firstName"
                    :maxLength="30"
                    :isTextOnly="true"
                    :errorInfo="errorInfo[1]"
                    :isShowError="false"
                    :isSubmitted="isSubmitted"
                    :inputLbl="lbl.register.firstname"
                    @update:inputValue="onFormChange()"
            ></InputText>
            <InputText
                    v-model:inputValue="registerModel.lastName"
                    :maxLength="30"
                    :isTextOnly="true"
                    :errorInfo="errorInfo[2]"
                    :isShowError="false"
                    :isSubmitted="isSubmitted"
                    :inputLbl="lbl.register.lastname"
                    @update:inputValue="onFormChange()"
            ></InputText>
            <InputContactNumber
                    v-model:inputValue="registerModel.tel"
                    :maxLength="12"
                    :minLength="12"
                    delimeter="-"
                    :errorInfo="errorInfo[3]"
                    :isShowError="false"
                    :isSubmitted="isSubmitted"
                    :inputLbl="lbl.register.contactNumber"
                    @update:inputValue="onFormChange()"
            ></InputContactNumber>
            <InputCalendar
                    v-model:inputValue="registerModel.birthdate"
                    :upperLimit="new Date()"
                    dateFormat="dd MMM yyyy"
                    :inputLbl="lbl.register.birthdate"
                    :errorInfo="errorInfo[4]"
                    :isShowError="false"
                    :isSubmitted="isSubmitted"
                    :isRight="true"
                    @update:inputValue="onFormChange()"
            ></InputCalendar>
        </div>
        <div>
            <InputEmail
                    v-model:inputValue="registerModel.email"
                    :maxLength="30"
                    :errorInfo="errorInfo[5]"
                    :isShowError="false"
                    :isSubmitted="isSubmitted"
                    :inputLbl="lbl.register.email"
                    @update:inputValue="onFormChange()"
            ></InputEmail>
        </div>
    </div>
</template>
<script>
import { FormHelper } from '@/helper/FormHelper';
import CacheHelper from '@/helper/CacheHelper.js';
import { CacheKey } from '@/helper/StaticValue';
import Util from '@/helper/Utility.js';
import DatetimeHelper from '@/helper/DatetimeHelper.js';
import FBFunction from '@/helper/facade/FBFunction'
//component
import InputRadio from '@/components/Input/label/InputRadio.vue'
import InputText from '@/components/Input/label/InputText.vue';
import InputContactNumber from '@/components/Input/label/InputContactNumber.vue';
import InputCalendar from '@/components/Input/label/InputCalendar.vue';
import InputEmail from '@/components/Input/label/InputEmail.vue';
//mixin
import LocaleMixin from '@/mixin/LocaleMixin';
import ModalMixin from '@/mixin/ModalMixin';
//service
import { RegisterModel, RegisterFormInit } from '../../model/RegisterModel.js';
import BzbsPDPA from '@/core/PDPA/service/BzbsPDPA.js';
//composable
import useFirebaseAuth from '@/module/Login/composable/useFirebaseAuth';

export default {
    mixins: [LocaleMixin, ModalMixin],
    components: {
        InputRadio,
        InputText,
        InputContactNumber,
        InputCalendar,
        InputEmail,
    },
    data: function () {
        return {
            registerModel: new RegisterModel(),
            prefixList: RegisterFormInit.genPrefix(),
            errorInfo: FormHelper.genErrorInfo(6),
            isSubmitted: false,
            formInit: false,

            pdpaVersion: {
                terms: 1,
                privacy: 1,
                marketing: 1,
            },
        };
    },
    setup: function () {
        const googleAuth = useFirebaseAuth()
        return {
            googleAuth
        }
    },
    created: function () {
        this.loadCacheForm();
        this.getPdpaVersion();

        if (this.$route.name == 'register_facebook') {
            this.setupFacebookRegister();
        } else if (this.$route.name == 'register_google') {
            this.setupGoogleRegister();
        } else {
            this.formInit = true;
        }
    },
    methods: {
        getPdpaVersion: function () {
            BzbsPDPA.apiGetPDPAVersion().subscribe({
                next: (data) => {
                    console.log('pdap version', data);
                    this.pdpaVersion.terms = data.terms.current_version;
                    this.pdpaVersion.privacy = data.privacy.current_version;
                    this.pdpaVersion.marketing = data.marketingOption.current_version;
                },
                error: (err) => {
                    this.errorApi(err);
                },
            })
        },
        setupFacebookRegister: function () {
            console.log('setup facebook register');
            let fb = new FBFunction();
            fb.getFbProfile().then((data) => {
                console.log('fb profile', data);
                this.registerModel.firstName = data.firstname;
                this.registerModel.lastName = data.lastname;
                this.registerModel.email = data.email;

                this.registerModel.isFacebookRegister = true;
                this.formInit = true;
            }).catch(() => {
                this.formInit = true;
            });
        },
        setupGoogleRegister: function () {
            this.googleAuth.getAuthUser().then((user)=>{
                console.log('user',user)
                if (user) {
                    let nameSplit = user.displayName.split(" ");
                    this.registerModel.firstName = nameSplit[0];
                    this.registerModel.lastName = nameSplit[1] ? nameSplit[1]: '';
                    this.registerModel.email = user.email;
                    this.registerModel.isGoogleRegister = true;
                    this.formInit = true;
                }
            });
            
            
            // this.googleAuth.getRedirectResult().then((token)=>{
            //     console.log(token);
            //     if (token && token.idToken) {
            //         console.log("token",this.googleAuth.user.value);
            //     } else {
            //         this.googleAuth.getAuthUser();
            //         if (this.googleAuth.user.value) {
            //             let nameSplit = this.googleAuth.user.value.displayName.split(" ");
            //             this.registerModel.firstName = nameSplit[0];
            //             this.registerModel.lastName = nameSplit[1] ? nameSplit[1]: '';
            //             this.registerModel.email = this.googleAuth.user.value.email;

            //             this.registerModel.isGoogleRegister = true;
            //             this.formInit = true;
            //             console.log("have user",this.googleAuth.user.value);
            //         } else {
            //             console.log("no user",this.googleAuth.user.value);
            //         }
                    
            //     }
            // });
        
            
            // this.googleAuth.getAuthUser();
            // console.log(this.googleAuth.user.value);
            // if (this.googleAuth.user.value) {
            //     this.registerModel.email = this.googleAuth.user.value.email;
            // } else {
            //     this.googleAuth.signInWithRedirect();
            // }
        },
        validateForm: function () {
            Util.log(this.errorInfo);
            let rs = FormHelper.validate(this.errorInfo);

            if (rs) {
                // check time
                let currentDate = new Date();
                let dateCheck = DatetimeHelper.compareYear(this.registerModel.birthdate, currentDate, 10);
                // console.log('date check', dateCheck);

                if (dateCheck > 0) {
                    this.errorInfo[4].setValid(false);
                    this.errorInfo[4].setMsg('อายุไม่ถึง');
                    rs = false;
                }
            }
            return {
                rs: rs,
                error: FormHelper.getFirstErrorItem(this.errorInfo),
            };
        },
        getFormValue: function () {
            this.registerModel.setTerms(this.pdpaVersion.terms);
            this.registerModel.setPrivacy(this.pdpaVersion.privacy);
            this.registerModel.setMarketing(this.pdpaVersion.marketing);
            return this.registerModel;
        },

        onFormChange: function () {
            this.saveCacheForm();
            this.$emit('update:inputValue', this.validateForm());
        },
        saveCacheForm: function () {
            let cache = new CacheHelper('session');
            cache.setCache(CacheKey.formRegister, this.registerModel);
        },
        loadCacheForm: function () {
            let cache = new CacheHelper('session');
            let cacheRegister = cache.getCache(CacheKey.formRegister);

            if (cacheRegister != null) {
                this.registerModel.setValueFromCache(cacheRegister);
            }
        },
    },
}
</script>
<style lang="scss" scoped>
</style>
